import * as React from 'react';
import { UIHeading4, InlineText2, IconSalesStart16, Button } from '@cian/ui-kit';

import { IHouseStats } from '../../../../types/newbuilding/genplan';
import { HouseStats } from '../HouseStats';

import * as styles from './styles.css';
import { Label, ReliableLabel } from '../HouseLabels';

interface IHouseTooltipProps {
  name: string;
  houseInfo: string[];
  houseId: number;
  stats?: IHouseStats | null;
  isReliable: boolean;
  isEscrow: boolean;
  isSalesStart?: boolean;
  onLinkClick(houseId: number, rooms?: string): void;
  onReliableLabelClick(event: React.MouseEvent<HTMLElement>): void;
  onEscrowLabelClick(event: React.MouseEvent<HTMLElement>): void;
  isFloorPlanEnabled: boolean;
  onFloorPlanClick(): void;
}

export function HouseTooltip({
  name,
  houseInfo,
  houseId,
  stats,
  isReliable,
  isEscrow,
  isSalesStart,
  onLinkClick,
  onReliableLabelClick,
  onEscrowLabelClick,
  isFloorPlanEnabled,
  onFloorPlanClick,
}: IHouseTooltipProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['title']}>
        <UIHeading4>{name}</UIHeading4>
        {isSalesStart && (
          <div className={styles['sales-start']}>
            <IconSalesStart16 color="error_100" viewBox="-1 -1 18 18" />
          </div>
        )}
      </div>

      <div className={styles['house-info']}>
        {houseInfo.map((item, i) => (
          <InlineText2 key={item} color="gray60_100" whiteSpace="nowrap">
            {item}
            {i < houseInfo.length - 1 ? ' • ' : ''}
          </InlineText2>
        ))}
      </div>
      {(isReliable || isEscrow) && (
        <div className={styles['labels']}>
          {isReliable && <ReliableLabel onClick={onReliableLabelClick}>Надежный корпус</ReliableLabel>}
          {isEscrow && <Label onClick={onEscrowLabelClick}>Эскроу</Label>}
        </div>
      )}
      {stats && <HouseStats {...stats} houseId={houseId} onLinkClick={onLinkClick} />}
      {!stats && (
        <div className={styles['line']}>
          <InlineText2>Нет квартир в продаже</InlineText2>
        </div>
      )}
      {stats && isFloorPlanEnabled && (
        <div className={styles['floor-plan-button']}>
          <Button theme="fill_secondary" size="XS" fullWidth onClick={onFloorPlanClick}>
            Квартиры на этажах
          </Button>
        </div>
      )}
    </div>
  );
}
